const panelMixin = {
    data () {
        return {
            panelMixin_isUserMrt: $store.getters['user-state/isUserMrt'],
            panelMixin_isUserMrtEnterprise: $store.getters['user-state/isUserMrtEnterprise'],
        }
    },
    methods: {
        panelMixin_getUserSettingServerIP () {
            let api = {
                verb: params.verb,
                service: moduleAjaxService,
                url: baseUrl + '/topDestination/' + params.destinationId,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        panelMixin_setTopDestination(params, callFunc = null) {
            let dispatch = 'voip-destination-api/setTopDestination'
            if (this.panelMixin_isUserMrt || this.panelMixin_isUserMrtEnterprise) {
                dispatch = 'voip-mrt-destinations-api/setTopDestination'
            }

            $store.dispatch(dispatch, params, {root: true}).then( (r) => {
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getTopDestinations(params, callFunc = null) {
            let dispatch = 'voip-destination-api/getTopDestination'
            if (this.panelMixin_isUserMrt || this.panelMixin_isUserMrtEnterprise) {
                dispatch = 'voip-mrt-destinations-api/getTopDestination'
            }

            $store.dispatch(dispatch, params, {root: true}).then( (r) => {
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getVendorDestinations(params, callFunc = null) {
            let dispatch = 'voip-vendor-api/dropDownDestinationsList'
            if (this.panelMixin_isUserMrt) {
                dispatch = 'voip-mrt-vendor-api/dropDownDestinationsList'
            }
            if (this.panelMixin_isUserMrtEnterprise) {
                dispatch = 'voip-mrt-enterprise-vendor-api/dropDownDestinationsList'
            }

            $store.dispatch(dispatch, params, {root: true}).then( (r) => {
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getVendorDivisionByName(params, callFunc = null) {
            let dispatch = 'voip-vendor-api/getVendorDivisionByName'
            if (this.panelMixin_isUserMrt) {
                dispatch = 'voip-mrt-vendor-api/getVendorDivisionByName'
            }
            if (this.panelMixin_isUserMrtEnterprise) {
                dispatch = 'voip-mrt-enterprise-vendor-api/getVendorDivisionByName'
            }

            $store.dispatch(dispatch, params, {root: true}).then( (r) => {
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_createVendorDestinationStatus(params, callFunc = null) {
            let dispatch = 'voip-vendor-destination-status-api/create'
            if (this.panelMixin_isUserMrt || this.panelMixin_isUserMrtEnterprise) {
                dispatch = 'voip-vendor-destination-status-api/mrtCreate'
            }

            $store.dispatch(dispatch, params, {root: true}).then( (r) => {
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getBroadcastHistory(params, callFunc = null) {
            let dispatch = 'voip-testing-panel-api/getBroadcastHistory'
            if (this.panelMixin_isUserMrt || this.panelMixin_isUserMrtEnterprise) {
                dispatch = 'voip-testing-panel-api/getMrtBroadcastHistory'
            }

            $store.dispatch(dispatch, params).then( (r) => {
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getUserVoipDivision(propName, callFunc = null) {
            let dispatch = 'voip-rate-division-api/getDropDownList'
            if (this.panelMixin_isUserMrt) {
                dispatch = 'voip-mrt-rate-division-api/getDropDownList'
            }
            if (this.panelMixin_isUserMrtEnterprise) {
                dispatch = 'voip-mrt-enterprise-rate-division-api/getDropDownList'
            }

            $store.dispatch(dispatch).then( (r) => {
                this[propName] = r
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getVendorsDropdownByDivision(propName, params, callFunc = null) {
            let dispatch = 'voip-vendor-api/getDropDownList'
            if (this.panelMixin_isUserMrt) {
                dispatch = 'voip-mrt-vendor-api/getDropDownList'
            }
            if (this.panelMixin_isUserMrtEnterprise) {
                dispatch = 'voip-mrt-enterprise-vendor-api/getDropDownList'
            }
            $store.dispatch(dispatch, params).then( (r) => {
                this[propName] = r
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getVendorsDropdown(propName, callFunc = null) {
            let dispatch = 'voip-vendor-api/getDropDownList'
            if (this.panelMixin_isUserMrt || this.panelMixin_isUserMrtEnterprise) {
                dispatch = 'voip-mrt-vendor-api/getDropDownList'
            }
            $store.dispatch(dispatch).then( (r) => {
                this[propName] = r
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getDestinations(propName, callFunc = null) {
            let dispatch = 'voip-destination-api/getDropDownList'
            if (this.panelMixin_isUserMrt || this.panelMixin_isUserMrtEnterprise) {
                dispatch = 'voip-mrt-destinations-api/getDropDownList'
            }
            $store.dispatch(dispatch).then( (r) => {
                this[propName] = r
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getDestinationRate(params, callFunc = null) {
            let dispatch = 'voip-destination-api/getDestinationRate'
            if (this.panelMixin_isUserMrt || this.panelMixin_isUserMrtEnterprise) {
                dispatch = 'voip-mrt-destinations-api/getDestinationRate'
            }
            $store.dispatch(dispatch, params).then( (r) => {
                if (callFunc) callFunc(r)
            })
        },
    }
};

export default panelMixin
